<template>
<main class="home">
  <scroll-view>
    <template slot-scope="visibility">
      <component :is="component" v-for="component in homeComponents" 
        :key="component" 
        :home="home" 
        :site="site" 
        :visible="visibility[component]" 
        :isBgLight="false"
        :isLandingMounted="isLanding"
        @dotColor="dotColorToApp($event)"
        @mountedLanding="isLandingMounted"
        :currentLang="currentLang"
        :buttonText="home[currentLang].buttonText"
        />
    </template>
  </scroll-view>
</main>
</template>

<script>
  const Landing = () => import( /* webpackChunkName: "Landing" */ '@/modules/Landing.vue');
  const Expertise = () => import( /* webpackChunkName: "Expertise" */ '@/modules/Expertise.vue');
  const Projects = () => import( /* webpackChunkName: "Projects" */ '@/pages/Projects.vue');
  const Faq = () => import( /* webpackChunkName: "Faq" */ '@/modules/Faq.vue');
  const Testimonials = () => import( /* webpackChunkName: "Testimonials" */ '@/modules/Testimonials.vue');
  const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');

import { $scrollview } from 'vue-scrollview'
  import {
    mapState
  } from 'vuex'
  export default {
    props:['currentLang'],
    name: 'Home',
    components: {
      Landing,
      Projects,
      Expertise,
      Testimonials,
      Faq,
      ContactFooter
    },
    data(){
      return {
        isLanding: false,
        homeComponents: ['Landing','Expertise', 'Projects', 'Testimonials', 'Faq', 'ContactFooter'],
        scrollView: $scrollview
      }
    },
    computed: mapState(['site', 'home']),
    methods: {
      isLandingMounted(){
        this.isLanding = true;
        this.$emit('mountedPage', {isBgLight: true});
      },
      dotColorToApp(payload){
        this.$emit('dotColorToApp', payload);
      }
    },
    beforeDestroy(){
      this.dotColorToApp('#ff0038');
    }
  }
</script>

<style lang="scss">
  main{
     min-height: 100vh;
  }
</style>
